/**
 * @module geo/middleware
 */
import {Action} from 'redux';
import {Epic} from 'redux-observable';
import {Observable} from 'rxjs';
import {Action as ActionFsa, isType} from 'typescript-fsa';

import {addToSelectionAsyncCreator, addToSelectionCreator, removeFromSelectionAsyncCreator, removeFromSelectionCreator, resetSelectionAsyncCreator, resetSelectionCreator} from '../actions/creators';
import busService from '../bus';
import {ADD_TO_SELECTION, REMOVE_FROM_SELECTION} from '../payload/facade';
import {RESET_SELECTION} from '../payload/facade/RESET_SELECTION';
import {Acknowledged} from '../payload/response/acknowledged';
import {AppStore} from '../store/app';

/**
 * @private
 *
 */
export const resetSelectionEpic: Epic<Action, AppStore> =
    (action$, store, uid) =>
        action$.filter(action => isType(action, resetSelectionCreator))
            .mergeMap((action) => {
              const actionFsa = action as ActionFsa<RESET_SELECTION>;
              return Observable
                  .fromPromise(busService.geoBus.send<Acknowledged>(
                      resetSelectionCreator.type, actionFsa.payload,
                      store.getState().uid))
                  .map(
                      result => resetSelectionAsyncCreator.done(
                          {params: actionFsa.payload, result}));
            });
/**
 * @private
 *
 */
export const addToSelectionEpic: Epic<Action, AppStore> =
    (action$, store, uid) =>
        action$.filter(action => isType(action, addToSelectionCreator))
            .mergeMap((action) => {
              const actionFsa = action as ActionFsa<ADD_TO_SELECTION>;
              return Observable
                  .fromPromise(busService.geoBus.send<Acknowledged>(
                      addToSelectionCreator.type, actionFsa.payload,
                      store.getState().uid))
                  .map(
                      result => addToSelectionAsyncCreator.done(
                          {params: actionFsa.payload, result}));
            });
/**
 * @private
 *
 */
export const removeFromSelectionEpic: Epic<Action, AppStore> =
    (action$, store, uid) =>
        action$.filter(action => isType(action, removeFromSelectionCreator))
            .mergeMap((action) => {
              const actionFsa = action as ActionFsa<REMOVE_FROM_SELECTION>;
              return Observable
                  .fromPromise(busService.geoBus.send<Acknowledged>(
                      removeFromSelectionCreator.type, actionFsa.payload,
                      store.getState().uid))
                  .map(
                      result => removeFromSelectionAsyncCreator.done(
                          {params: actionFsa.payload, result}));
            });
